import { useNode } from '@craftjs/core';
import { useEditor as useTipTapEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import Placeholder from '@tiptap/extension-placeholder';
import { cn } from '../../../../lib/utils';

interface TextBlockProps {
  text: string;
  fontSize: number;
  fontFamily: string;
  color: string;
  textAlign: string;
}

export function TextBlock({ text, fontSize, fontFamily, color, textAlign }: TextBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  const editor = useTipTapEditor({
    extensions: [
      StarterKit,
      Link.configure({ openOnClick: false }),
      TextAlign.configure({ types: ['heading', 'paragraph'] }),
      Underline,
      Placeholder.configure({ placeholder: 'Digite seu texto aqui...' }),
    ],
    content: text,
    onUpdate: ({ editor: e }) => {
      setProp((props: TextBlockProps) => {
        props.text = e.getHTML();
      });
    },
    editable: true,
  });

  return (
    <div
      ref={(ref) => {
        if (ref) connect(ref);
      }}
      className={cn(
        'min-h-[40px] rounded transition-all group relative',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
      style={{ fontSize: `${fontSize}px`, fontFamily, color, textAlign: textAlign as React.CSSProperties['textAlign'] }}
    >
      {/* Drag handle — only visible on hover */}
      <div
        ref={(ref) => { if (ref) drag(ref); }}
        className="absolute -left-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-60 cursor-grab p-0.5"
        title="Arrastar"
      >
        <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" className="text-muted-foreground">
          <circle cx="5" cy="3" r="1.5" /><circle cx="11" cy="3" r="1.5" />
          <circle cx="5" cy="8" r="1.5" /><circle cx="11" cy="8" r="1.5" />
          <circle cx="5" cy="13" r="1.5" /><circle cx="11" cy="13" r="1.5" />
        </svg>
      </div>
      <div className="p-2">
        <EditorContent editor={editor} />
      </div>
    </div>
  );
}

TextBlock.craft = {
  displayName: 'Texto',
  props: {
    text: '<p>Seu texto aqui</p>',
    fontSize: 16,
    fontFamily: 'inherit',
    color: '#ffffff',
    textAlign: 'left',
  },
  rules: { canDrag: () => true },
};
